import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { Botao, BotaoMenu } from '../funcionalidade-core/shared/botao.model';

export interface DialogButton extends BotaoMenu {
  action: string;
  type: 'simple' | 'dropdown';
}

export interface TabOption {
  id: number;
  label: string;
}

@Component({
  selector: 'app-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.css']
})
export class DialogHeaderComponent {
  @Input() title: string = '';
  @Input() buttons: DialogButton[] = [];
  @Input() maximizado: boolean = false;
  @Input() element: any; 
  @Input() templateAcoes: TemplateRef<any>;
  
  @Input() showTabs: boolean = false;
  @Input() tabs: TabOption[] = [];
  @Input() selectedTab: number = 0;
  @Output() tabChange = new EventEmitter<number>();

  @Input() showErrorBanner: boolean = false;
  @Input() errorTitle: string = 'ATENÇÃO:';
  @Input() errorMessages: string[] = [];
  @Output() closeErrorBanner = new EventEmitter<void>();

  @Output() maximize = new EventEmitter<void>();
  @Output() restore = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onTabChange(tabId: number): void {
    this.selectedTab = tabId;
    this.tabChange.emit(tabId);
  }

  onCloseErrorBanner(): void {
    this.closeErrorBanner.emit();
  }

  onMaximize(): void {
    this.maximize.emit();
  }

  onRestore(): void {
    this.restore.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}
